import { Action } from "@ngrx/store";
import { LoadCustomUserPayloadEventModel } from "../../custom-user.model";

export const REGISTERED_USER_SUCCESS = '[Custom User] Register User Success';
export const REGISTERED_USER_FAIL = '[Custom User] Register User Fail';
export const REGISTERED_NEWSLETTER_SUCCESS = '[Custom User] Register Newsletter Success';


export class UserRegisteredSuccess implements Action {
  readonly type = REGISTERED_USER_SUCCESS;

  constructor(public payload: LoadCustomUserPayloadEventModel) {
  }
}

export class UserRegisteredFail implements Action {
  readonly type = REGISTERED_USER_FAIL;

  constructor(public payload: LoadCustomUserPayloadEventModel) {
  }
}

export class NewsletterRegisteredSuccess implements Action {
  readonly type = REGISTERED_NEWSLETTER_SUCCESS;

  constructor(public payload: LoadCustomUserPayloadEventModel) {
  }
}


export type CustomUserAction =
  | UserRegisteredSuccess
  | UserRegisteredFail
  | NewsletterRegisteredSuccess

